import React, { useRef, useEffect, useMemo, useState } from "react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { Text, RichText } from "@sitecore-jss/sitecore-jss-react";
import CarExteriorViewer from "../../sections/car-exterior-viewer";
import CarInteriorViewer from "../../sections/car-interior-viewer";
import { getOverallSettingsClasses, componentId } from "../../utils/siteUtils";
import "./style.scss";
const Car360ViewV2 = props => {
  const { rendering, fields, params } = props;
  const { models, title, text, interiorModels, hideInteriorModels } = fields;
  const rootNode = useRef()
  const { t } = useTranslation();
  const exteriorSwitcherText = t('Car360ViewV2_Exterior') || 'Appearance';
  const interiorSwitcherText = t('Car360ViewV2_Interior') || 'Interior';
  const viewerName = 'Car360ViewV2';
  const [modelIndex, setModelIndex] = useState(0);
  const [interiorIndex, setInteriorIndex] = useState(0);
  const [showExterior, setShowExterior] = useState(true);
  
  useEffect(() => {
    if (hideInteriorModels?.value) {
      setShowExterior(true);
    }
  }, [hideInteriorModels?.value]);
  const onModelChange = (e, index) => {
    setModelIndex(index);
  };
  const onInteriorChange = (e, index) => {
    setInteriorIndex(index);
  };
  const colorList = [];
  const getColorList = () => {
    let color = '';
    models.forEach(c => {
      color = c.fields.switcherColorLeft.value + ',' + c.fields.switcherColorRight.value;
      color && colorList.push(color);
    });
    return colorList;
  }
  useEffect(() => {
    getColorList();
  }, []);
  const rootId = componentId(rendering);
  const rootClasses = classNames("c-car360-view-v2", getOverallSettingsClasses(fields));
  return (
    <div className={rootClasses} datasourceid={rendering.dataSource} ref={rootNode} id={rootId}>
      <div className="c-car360-view-v2__toolbar">
        <Text tag="div" className="c-car360-view-v2__title" field={title} />
        <RichText tag="div" className="c-car360-view-v2__subTitle" field={text} />
      </div>
      <div className={classNames("c-car360-view-v2__main", { interior: !showExterior })}>
        {showExterior && <CarExteriorViewer {...{ fields, modelIndex, onModelChange, viewerName }} />}
        {!showExterior && !hideInteriorModels.value && <CarInteriorViewer {...{ interiorModels, models, modelIndex, interiorIndex, onModelChange, onInteriorChange, viewerName }} />}
      </div>
      <div className="c-car360-view-v2__switcher">
        <div className={classNames("c-car360-view-v2__switcher-item", { active: showExterior })} onClick={e => setShowExterior(true)}>
          {exteriorSwitcherText}
        </div>
        {!hideInteriorModels.value && <div className={classNames("c-car360-view-v2__switcher-item", { active: !showExterior })} onClick={e => setShowExterior(false)}>
            {interiorSwitcherText}
          </div>}
      </div>

    </div>
  );
};
export default Car360ViewV2;
